<template>
    <div class="rests_times">
        <b-overlay :show="is_load" rounded="sm">
            <times :times="this.location.times"></times>
            <div class="sync_it w-100 mt-4">
                <button type="button" v-on:click="sync_times" class="btn btn-primary waves-effect waves-themed w-100">
                    {{__t('SYNC_TIME')}}
                </button>
            </div>
        </b-overlay>
    </div>
</template>

<script>
import times from "../../../../times/times";

export default {
    name: "bolt_work_hour",
    props : {
        location : {
            type : Object
        }
    },
    components : {
        times
    },

    data() {
        return {
            cur_rest : this.rest,
            is_load: false,
        }
    },

    methods : {
        async sync_times() {
            this.is_load = true;
            agr_api.patch('/aggregators/bolt/location/' + this.location.id + "/sync_time").then(({data}) => {
                this.is_load = false;
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        }
    },
}
</script>

<style scoped>

</style>
